import * as React from "react";
import {useEffect, useState} from "react";
import 'brace/mode/groovy'
import 'brace/mode/xml'
import 'brace/mode/json'
import 'brace/mode/yaml'
import 'brace/ext/searchbox'
import {CsvViewer} from "./CsvViewer";
import {XlsxViewer} from "./XlsxViewer";
import LogeniosErrorBoundary from "../../../ErrorBoundary";
import {ConverterAidedFileViewer} from "./ConverterAidedFileViewer";
import {JsonMailViewer} from "./JsonMailViewer";
import {TextFileViewer} from "./TextFileViewer";
import {ImageViewer} from "./ImageViewer";


export interface DisplayFileProps {
    fileBuffer: ArrayBuffer;
    fileName: string;
    displayName: boolean;
}

export function FileViewer(props: DisplayFileProps) {

    const [displayedElement, setDisplayedElement] = useState<JSX.Element>(<>Loading...</>)

    useEffect(() => {
        if (props.fileBuffer) {
            drawFilePreview().then(element => {
                setDisplayedElement(element)
            })
        }
    }, [props.fileBuffer])

    function mimeType() {
        switch (fileTypeByFileName(props.fileName)) {
            case 'png':
                return 'image/png'
            case 'jpg':
            case 'jpeg':
                return 'image/jpeg'
            case 'pdf':
                return 'application/pdf'
            case 'xlsx':
            case 'xls':
                return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            case 'docx':
                return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            case 'doc':
                return 'application/msword'
            default:
                return 'text/plain'
        }
    }

    function getBlob() {
        return new Blob([props.fileBuffer], {type: mimeType()})
    }

    async function drawFilePreview() {
        switch (fileTypeByFileName(props.fileName)) {
            case 'csv': {
                return <LogeniosErrorBoundary><CsvViewer blob={getBlob()}/></LogeniosErrorBoundary>
            }
            case 'xls':
            case 'xlsx': {
                return <LogeniosErrorBoundary><XlsxViewer fileBuffer={props.fileBuffer}/></LogeniosErrorBoundary>
            }
            case 'png':
            case 'jpg':
            case 'jpeg': {
                return <LogeniosErrorBoundary><ImageViewer blob={getBlob()}/></LogeniosErrorBoundary>
            }
            case 'doc':
            case 'docx':
            case 'jsonmail': {
                return <LogeniosErrorBoundary>
                    <JsonMailViewer
                        blob={getBlob()}
                        fileName={props.fileName}
                        fileBuffer={props.fileBuffer}
                    />
                </LogeniosErrorBoundary>
            }
            case 'eml':
            case 'html':
            case 'pdf': {
                return <LogeniosErrorBoundary><ConverterAidedFileViewer blob={getBlob()} fileName={props.fileName}/></LogeniosErrorBoundary>
            }
            default: {
                return <LogeniosErrorBoundary><TextFileViewer buffer={props.fileBuffer} fileName={props.fileName}/></LogeniosErrorBoundary>
            }
        }
    }

    return <div style={{display: 'flex', flexDirection: 'column', height: '100%', flex: 1}}>
        {props.displayName && <h5 style={{margin: '5px 0'}}>{props.fileName}</h5>}
        <div style={{flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden'}}>
            {displayedElement}
        </div>
    </div>

}

export function fileTypeByFileName(fileName: string) {
    console.log("checking filetype of " + fileName)
    let ending = fileName.toLowerCase().split('.').pop()
    if (ending === 'exp' || ending === 'xsl') {
        return 'xml'
    }
    return ending
}